import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    title = 'Espire';
}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/app.component.ts